import { Button } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './Pagination.css';

interface IPaginationProps {
  loading: boolean;
  onClick: VoidFunction;
}

export const Pagination: React.FC<IPaginationProps> = ({ loading, onClick }) => {
  return (
    <div className={styles['container']}>
      <Button type="button" size="XS" onClick={onClick} loading={loading}>
        Показать ещё
      </Button>
    </div>
  );
};
